import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { profileStore, projectStore } from '~/stores'
import { memo, observer } from '~/ui/component'
import { Center, Spinner } from '~/ui/components'
import { AppLayout } from '~/ui/layouts'
import BeWizrCourseScreen from '../bewizr-courses/BeWizrCourseScreen'
import BeWizrCoursesScreen from '../bewizr-courses/BeWizrCoursesScreen'
import BeWizrReadOnlyCoursesScreen from '../bewizr-courses/BeWizrReadOnlyCoursesScreen'
import BeWizrLearningTrackScreen from '../bewizr-learning-tracks/BeWizrLearningTrackScreen'
import BeWizrLibraryScreen from '../bewizr-library/BeWizrLibraryScreen'
import BeWizrLibraryTopicScreen from '../bewizr-library/BeWizrLibraryTopicScreen'
import BeWizrLibraryTopicsScreen from '../bewizr-library/BeWizrLibraryTopicsScreen'
import BeWizrMeetingScreen from '../bewizr-meetings/BeWizrMeetingScreen'
import BeWizrMiscItemScreen from '../bewizr-misc-items/BeWizrMiscItemScreen'
import ChallengeScreen from '../challenges/ChallengeScreen'
import ChallengesScreen from '../challenges/ChallengesScreen'
import ChallengeTaskScreen from '../challenges/tasks/ChallengeTaskScreen'
import ConnectionsScreen from '../connections/ConnectionsScreen'
import { PageNotFoundScreen } from '../errors'
import HomeScreen from '../home/HomeScreen'
import InfoScreen from '../info/InfoScreen'
import NewsScreen from '../news/NewsScreen'
import PostScreen from '../news/PostScreen'
import NotificationsScreen from '../notifications/NotificationsScreen'
import ParticipantScreen from '../participants/ParticipantScreen'
import ProfileScreen from '../profile/ProfileScreen'
import QAndAScreen from '../q-and-as/QAndAScreen'
import RankingsScreen from '../rankings/RankingsScreen'
import SearchScreen from '../search/SearchScreen'
import BeWizrCalendarScreen from '../bewizr-library/BeWizrCalendarScreen'

export interface Props {}

const RootNavigator = observer('RootNavigator', (props: Props) => {

  const participant = profileStore.participant
  const project     = projectStore.project

  if (participant == null || project == null) {
    return <TransitionScreen/>
  }

  return (
    <AppLayout>
      <Switch>
        <Route exact path='/login' component={TransitionScreen}/>
        <Route path='/auth' component={TransitionScreen}/>
        <Route path='/home' component={HomeScreen}/>
        <Route path='/profile' component={ProfileScreen}/>
        <Route path='/notifications' component={NotificationsScreen}/>
        <Route path='/search/:resource?' component={SearchScreen}/>
        <Route path='/-/*' component={InfoScreen}/>
        <Route path='/news' exact component={NewsScreen}/>
        <Route path='/posts/-/:id' component={PostScreen}/>
        <Route path='/challenges/-/:challengeID/tasks/:taskID' component={ChallengeTaskScreen}/>
        <Route path='/challenges/-/:id' component={ChallengeScreen}/>
        <Route path='/challenges' component={ChallengesScreen}/>
        <Route path='/q-and-as/-/:id' component={QAndAScreen}/>
        <Route path='/connections' component={ConnectionsScreen}/>
        <Route path='/participants/-/:id' component={ParticipantScreen}/>
        <Route path='/rankings/-/:competitionID' component={RankingsScreen}/>
        <Route path='/bewizr-courses/-/:slug' component={BeWizrCourseScreen}/>
        <Route path='/bewizr-courses/learning-tracks/-/:id' component={BeWizrLearningTrackScreen}/>
        <Route path='/bewizr-courses' component={BeWizrCoursesScreen}/>
        <Route path='/bewizr-readonly-courses' component={BeWizrReadOnlyCoursesScreen}/>
        <Route path='/bewizr-meetings/-/:id/occurrences/:occurrenceID' component={BeWizrMeetingScreen}/>
        <Route path='/bewizr-meetings/-/:id' component={BeWizrMeetingScreen}/>
        <Route path='/bewizr-topics/-/:slug' component={BeWizrLibraryTopicScreen}/>
        <Route path='/bewizr-topics' component={BeWizrLibraryTopicsScreen}/>
        <Route path='/bewizr-library/calendar' component={BeWizrCalendarScreen}/>
        <Route path='/bewizr-library' component={BeWizrLibraryScreen}/>
        <Route path='/bewizr-misc-items/:type/-/:id' component={BeWizrMiscItemScreen}/>
        <Route path='/bewizr-calendar' component={BeWizrCalendarScreen}/>
        <Route component={PageNotFoundScreen}/>
      </Switch>
    </AppLayout>
  )

})

interface TransitionScreenProps {}

const TransitionScreen = memo('TransitionScreen', (props: TransitionScreenProps) => {

  function render() {
    return (
      <Center flex>
        <Spinner/>
      </Center>
    )
  }

  return render()

})

export default RootNavigator